import { LanguageSupportUtil } from 'utils/language_support_util';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';
import logHomepageSignupButtonTapped from '@alltrails/analytics/events/logHomepageSignupButtonTapped';
import { FormattedMessage, defineMessages } from 'react-intl';
import Button from '@alltrails/shared/denali/components/Button';
import useFormatMessage from '@alltrails/shared/hooks/useFormatMessage';
import * as styles from './styles/styles.module.scss';
import ActivitySuitabilityRiver from './ActivitySuitabilityRiver';

const ACTIVITY_SUITABILITY_STRINGS = defineMessages({
  SIGN_UP: {
    defaultMessage: 'Sign up'
  }
});

type Props = {
  languageRegionCode: LanguageRegionCode;
  mobileBrowser: boolean;
  windowWidth: number;
  activities: {
    title: string;
    explore_url: string;
    photo_urls: {
      square: {
        two: string;
        three: string;
        urlWithoutExt: string;
      };
    };
  }[];
};
const SignupActivitySuitability = ({ activities, languageRegionCode, mobileBrowser, windowWidth }: Props): JSX.Element => {
  const {
    formattedDefaultMessages: { SIGN_UP }
  } = useFormatMessage(ACTIVITY_SUITABILITY_STRINGS);

  return (
    <div className={styles.container}>
      <div className={styles.signUp}>
        <h3 className={styles.header}>
          <FormattedMessage defaultMessage="Built (for everyone) to go wild" />
        </h3>
        <div className={styles.subText}>
          <FormattedMessage defaultMessage={"Whether you want a casual stroll or a trek to the summit, we've got you covered."} />
        </div>
        <Button
          text={SIGN_UP}
          linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe('/signup?ref=homepage_signup_signupactivitysuitability', languageRegionCode) }}
          onClick={() => logHomepageSignupButtonTapped()}
          testId="activity-suitability-sign-up"
        />
      </div>
      <div className={styles.activityCarousel}>
        <ActivitySuitabilityRiver
          activities={activities}
          mobileBrowser={mobileBrowser}
          windowWidth={windowWidth}
          languageRegionCode={languageRegionCode}
        />
      </div>
    </div>
  );
};

export default SignupActivitySuitability;
